// extracted by mini-css-extract-plugin
var _1 = "EpostFormFields-modulefieldsContainer___OSZX FormFieldsContainer-moduleFormFieldsContainer__u1JJu";
var _2 = "EpostFormFields-moduleregisteredLetterFieldInput__Mw1ow";
export { _1 as "fieldsContainer", _2 as "registeredLetterFieldInput" }
